import * as React from "react";
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { ITmdState } from "../../../reducers/index";
import "./TrialInstitutionLookupsLayout.scss";

interface ITrialInstitutionLookupsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface ITrialInstitutionLookupsLayoutActions {}

type TrialInstitutionLookupsLayoutProps = ITrialInstitutionLookupsLayoutProps &
    ITrialInstitutionLookupsLayoutActions;

class TrialInstitutionLookupsLayout extends React.PureComponent<
    TrialInstitutionLookupsLayoutProps,
    any
> {
    constructor(props: TrialInstitutionLookupsLayoutProps) {
        super(props);
    }

    render() {
        const { loading, permissions, permission } = this.props;

        return (
            <RestrictedLayout loading={loading}>
                {permissions.length > 0 &&
                permission &&
                !AuthenticationHelper.hasPermission(permissions, permission) ? (
                    <div className="alert alert-warning d-flex">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>Permission Denied</span>
                    </div>
                ) : (
                    this.props.children
                )}
            </RestrictedLayout>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialInstitutionLookupsLayoutProps
): ITrialInstitutionLookupsLayoutProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children,
    };
};

const mapDispatchToProps = (
    _dispatch
): ITrialInstitutionLookupsLayoutActions => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialInstitutionLookupsLayout);
